import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_BENEFITS_HISTORY_REQUEST = "GET_BENEFITS_HISTORY_REQUEST";
export const GET_BENEFITS_HISTORY_SUCCESS = "GET_BENEFITS_HISTORY_SUCCESS";
export const GET_BENEFITS_HISTORY_ERROR = "GET_BENEFITS_HISTORY_ERROR";

//* ACTIONS ------------------------------------------------
export const getBenefitsHistoryRequest = (payload = {}, callback) => ({
  type: GET_BENEFITS_HISTORY_REQUEST,
  payload,
  callback,
});

export const getBenefitsHistorySuccess = (data) => ({
  type: GET_BENEFITS_HISTORY_SUCCESS,
  payload: data,
});

export const getBenefitsHistoryError = (error) => ({
  type: GET_BENEFITS_HISTORY_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getBenefitsHistoryServiceRequest = async ({payrollId, ...params}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/benefits/payroll/${payrollId}/history`, options);
};
